// If the cell contains any of the below characters, then escape the whole contents by prefixing a single quote
// This is the easiest way to make sure the cell is not executed/evaluated/clickable
export const csvFormulaInjectionSanitizer = (str) => /^[=@+-]/.test(str) ? `'${str}` : str;